import Field from "@/components/Field";
import MonthSelect from "@/components/MonthSelect";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { isRequired } from "@/lib/form";
import { useProjectLimitsContext } from "@/modules/projects/components/limits/ProjectLimitsContext";
import { writeProjectLimitPeriod } from "@/schemas/projectLimit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { isProjectRoleDependent } from "../../lib/isProjectRoleDependent";
import { ProjectRoleOrDepartmentField } from "./ProjectRoleOrDepartmentField";
import { NumberInput } from "@/components/ui/NumberInput";

const ProjectLimitUpsertForm = () => {
  const { t } = useTranslation();
  const { project } = useProjectLimitsContext();
  const isRoleDependent = isProjectRoleDependent(project);

  const selectableFromDate = useMemo(() => {
    return project?.start_date ? new Date(project.start_date) : undefined;
  }, [project?.start_date]);

  const selectableToDate = useMemo(() => {
    return project?.end_date ? new Date(project.end_date) : undefined;
  }, [project?.end_date]);

  return (
    <Card className="grow-0 shrink-0 overflow-auto">
      <CardHeader>
        <CardTitle>{t("projectLimits.periodsDialog.formTitle")}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 w-[280px]">
        <div className="grid gap-4">
          <ProjectRoleOrDepartmentField
            isRoleDependent={isRoleDependent}
            projectId={project?.id}
          />
          <Field
            name="from"
            label={t("projectLimits.periodsDialog.fromMonth")}
            render={({ field }) => (
              <MonthSelect
                inDialog
                selectableFromDate={selectableFromDate}
                selectableToDate={selectableToDate}
                {...field}
              />
            )}
            required={isRequired(writeProjectLimitPeriod.shape.from)}
          />
          <Field
            name="to"
            label={t("projectLimits.periodsDialog.toMonth")}
            render={({ field }) => (
              <MonthSelect
                inDialog
                selectableFromDate={selectableFromDate}
                selectableToDate={selectableToDate}
                {...field}
              />
            )}
            required={isRequired(writeProjectLimitPeriod.shape.to)}
          />
          <Field
            name="hours"
            label={t("projectLimits.periodsDialog.hours")}
            render={({ field }) => <NumberInput {...field} />}
            required={isRequired(writeProjectLimitPeriod.shape.hours)}
          />
          <Field
            name="rate"
            label={t("projectLimits.periodsDialog.rate")}
            render={({ field }) => <NumberInput {...field} />}
            required={isRequired(writeProjectLimitPeriod.shape.rate)}
          />
          <Field
            name="addition"
            label={t("projectLimits.periodsDialog.addition")}
            render={({ field }) => <NumberInput {...field} />}
            required={isRequired(writeProjectLimitPeriod.shape.addition)}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectLimitUpsertForm;
